import {BirthdayMember} from '../../types/birthdays'
import './BirthdayListItem.css'

interface BirthdayListItemProps {
  birthday: BirthdayMember
  onOpenPreview?: (id: string) => void
}

export const BirthdayListItem = ({birthday, onOpenPreview}: BirthdayListItemProps) => {
  const fullName = `${birthday.firstName} ${birthday.middleName || ''} ${birthday.lastName} ${
    birthday.secondLastName || ''
  }`.replace(/\s+/g, ' ')

  return (
    <div
      className='birthday-list-item'
      onClick={() => onOpenPreview?.(birthday.id)}
    >
      <div className='birthday-list-icon'>
        <i className='bi bi-cake2-fill'></i>
      </div>
      <div className='birthday-list-content'>
        <div className='birthday-list-name'>{fullName}</div>
        <div className='birthday-list-details'>
          <span className='birthday-list-detail'>
            <i className='bi bi-person-badge'></i>
            {birthday.agentName}
          </span>
          <span className='birthday-list-detail'>
            <i className='bi bi-calendar-event'></i>
            Age: {birthday.age}
          </span>
          {birthday.phone && (
            <span className='birthday-list-detail'>
              <i className='bi bi-telephone'></i>
              {birthday.phone}
            </span>
          )}
        </div>
      </div>
    </div>
  )
}
